import React from 'react'
import { Icon } from '../Icon'
export const Logo = (props) => {

  return <div>
    <Icon icon="icon-Code" size={30}/> 碧空
  </div>
}
